import { post, get, qs } from './http.ts';
import type { AuthResponse, User, Namespace } from './types.ts';

export const login = (email: string, password: string): Promise<AuthResponse> =>
  post<AuthResponse>('/auth/login', { email, password });

export const signup = (
  email: string, password: string, displayName: string,
): Promise<AuthResponse> =>
  post<AuthResponse>('/auth/signup', { email, password, display_name: displayName });

export const logout = (): Promise<{ ok: boolean }> => post('/auth/logout');

export const me = (): Promise<{
  user: User; namespaces: Namespace[]; features?: { sharing: boolean };
}> => get('/auth/me');

export const changePassword = (
  currentPassword: string, newPassword: string, revokeOthers = true,
): Promise<{ ok: boolean }> =>
  post('/auth/password', {
    current_password: currentPassword,
    new_password: newPassword,
    revoke_others: revokeOthers,
  });

export const createPairingCode = (): Promise<{ code: string; expires_at: string }> =>
  post('/auth/pairing/code');

export const search = (namespaceId: string, query: string) =>
  get<{ items: import('./types.ts').ApiNode[] }>(
    `/search${qs({ namespace_id: namespaceId, q: query, limit: 20 })}`,
  );
